import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00521274"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page d-overflow d-full d-flex-column" }
const _hoisted_2 = { class: "head-bg-warp" }
const _hoisted_3 = { class: "statistics-warp d-flex" }
const _hoisted_4 = { class: "statistics-val" }
const _hoisted_5 = { class: "statistics-label" }
const _hoisted_6 = { class: "statistics-val" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "statistics-label" }, "邻里互助次数", -1))
const _hoisted_8 = { class: "statistics-val" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "statistics-label" }, "社区志愿时长", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "white-radius-bg" }, null, -1))
const _hoisted_11 = { class: "mutual-aid-warp" }
const _hoisted_12 = { class: "mutual-aid-title-warp d-flex" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex-1f" }, "邻里互助", -1))
const _hoisted_14 = { class: "mutual-aid-title-more" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mutual-aid-tabitem-title" }, "爱心求助", -1))
const _hoisted_16 = { class: "mutual-aid-tabitem-content-warp" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mutual-aid-tabitem-title" }, "互动咨询", -1))
const _hoisted_18 = { class: "mutual-aid-tabitem-content-warp" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mutual-aid-tabitem-title" }, "物资捐赠", -1))
const _hoisted_20 = { class: "mutual-aid-tabitem-content-warp" }
const _hoisted_21 = { class: "biaoti" }
const _hoisted_22 = { class: "title" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, "社区云课堂", -1))
const _hoisted_24 = { class: "right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_image = _resolveComponent("van-image")!
  const _component_RatioHeightContainer = _resolveComponent("RatioHeightContainer")!
  const _component_van_swipe_item = _resolveComponent("van-swipe-item")!
  const _component_van_swipe = _resolveComponent("van-swipe")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_HelpWithLoveItem = _resolveComponent("HelpWithLoveItem")!
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_interactiveOrActivity = _resolveComponent("interactiveOrActivity")!
  const _component_SuppliesItem = _resolveComponent("SuppliesItem")!
  const _component_van_tabs = _resolveComponent("van-tabs")!
  const _component_cloudClassItem = _resolveComponent("cloudClassItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.gotoDonationList && _ctx.gotoDonationList(...args)))
        }, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.homeTotal?.totalPoint?.format2({ simplifyDigits: true })) + "元", 1),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_van_icon, {
              name: "smile",
              class: "statistics-ico"
            }),
            _createTextVNode("社区公益基金 ")
          ])
        ]),
        _createElementVNode("div", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.gotoHelpList && _ctx.gotoHelpList(...args)))
        }, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.homeTotal?.helpCount?.format2({ simplifyDigits: true })) + "次", 1),
          _hoisted_7
        ]),
        _createElementVNode("div", {
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.gotoServiceDuration && _ctx.gotoServiceDuration(...args)))
        }, [
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.homeTotal?.serviceTime?.format2({ simplifyDigits: true })) + "小时", 1),
          _hoisted_9
        ])
      ]),
      _createVNode(_component_van_swipe, {
        class: "swipe-warp",
        autoplay: 3000,
        "lazy-render": ""
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.carouseImg, (item) => {
            return (_openBlock(), _createBlock(_component_van_swipe_item, {
              key: item.id,
              class: "swipe-item-warp"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_RatioHeightContainer, { ratio: 41.59 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_van_image, {
                      width: "100%",
                      height: "100%",
                      alt: "图片加载中...",
                      radius: 12,
                      fit: "cover",
                      class: "swipe-img",
                      src: _ctx.img(item.imgKey),
                      onClick: ($event: any) => (_ctx.nav(item))
                    }, null, 8, ["src", "onClick"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }),
      _hoisted_10
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_router_link, { to: { path: '/mulin/mutualAid/all' } }, {
            default: _withCtx(() => [
              _createTextVNode(" 查看更多")
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode(_component_van_tabs, {
        color: "#fff",
        animated: "",
        swipeable: "",
        "lazy-render": ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_tab, null, {
            title: _withCtx(() => [
              _hoisted_15
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_16, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formDataLoveHelp, (item, index) => {
                  return (_openBlock(), _createBlock(_component_HelpWithLoveItem, {
                    key: index,
                    "item-data": item,
                    type: 0
                  }, null, 8, ["item-data"]))
                }), 128))
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_van_tab, null, {
            title: _withCtx(() => [
              _hoisted_17
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_18, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formDataInteractive, (item, index) => {
                  return (_openBlock(), _createBlock(_component_interactiveOrActivity, {
                    "item-data": item,
                    key: index,
                    "not-border": index == _ctx.formDataInteractive.length - 1
                  }, null, 8, ["item-data", "not-border"]))
                }), 128))
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_van_tab, null, {
            title: _withCtx(() => [
              _hoisted_19
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_20, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formDataSupplies, (item, index) => {
                  return (_openBlock(), _createBlock(_component_SuppliesItem, {
                    "item-data": item,
                    key: index,
                    "not-border": index == _ctx.formDataSupplies.length - 1
                  }, null, 8, ["item-data", "not-border"]))
                }), 128))
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("div", _hoisted_22, [
        _hoisted_23,
        _createElementVNode("div", _hoisted_24, [
          _createVNode(_component_router_link, { to: { path: '/mulin/cloudClass' } }, {
            default: _withCtx(() => [
              _createTextVNode(" 查看全部")
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cloudClassRoomList, (item) => {
        return (_openBlock(), _createBlock(_component_cloudClassItem, {
          key: item,
          "item-data": item
        }, null, 8, ["item-data"]))
      }), 128))
    ])
  ]))
}